import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const ProjectButton = ({ project, t }) => {
  const { isRTL } = useLanguage();

  if (project.btnType === 'none') return null;

  if (project.btnType === 'comingSoon') {
    return (
      <a href="#!" className="group relative inline-flex items-center justify-center px-6 py-3 overflow-hidden rounded-md bg-transparent border border-white text-white shadow-sm transition-all duration-300">
        <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-blue-500 group-hover:w-full transition-all duration-700 ease-in-out"></span>
        <span className="relative flex items-center gap-3">
          <span className="font-medium">{t.portfolio.comingSoon}</span>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isRTL ? "M10 19l-7-7m0 0l7-7m-7 7h18" : "M14 5l7 7m0 0l-7 7m7-7H3"} />
          </svg>
        </span>
      </a>
    );
  }

  // --- card ---
  if (project.btnType === 'card') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="group relative inline-flex items-center justify-center px-6 py-3 overflow-hidden font-medium text-gray-800 bg-white rounded-md border border-gray-300 shadow-sm hover:shadow-md transition-shadow duration-300">
        <div className="absolute inset-0 w-3 bg-gradient-to-b from-blue-600 to-blue-800 group-hover:w-full transition-all duration-500 ease-out"></div>
        <div className="absolute bottom-0 right-0 w-12 h-12 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out">
          <svg className="w-full h-full text-blue-100 opacity-20" fill="currentColor" viewBox="0 0 60 60">
            <path d="M30,0 C13.4315,0 0,13.4315 0,30 C0,46.5685 13.4315,60 30,60 C46.5685,60 60,46.5685 60,30 C60,13.4315 46.5685,0 30,0 Z" />
          </svg>
        </div>
        <span className="relative flex items-center gap-2 text-gray-800 group-hover:text-white transition-colors duration-300">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <span className="font-semibold">{t.portfolio.seeCard}</span>
        </span>
        <div className="absolute -bottom-16 right-0 opacity-0 group-hover:opacity-100 group-hover:-translate-y-20 transition-all duration-500 ease-out">
          <div className="bg-white w-32 h-20 rounded-md shadow-xl p-2 border border-gray-300 text-xs text-gray-700 flex flex-col justify-between transform rotate-6">
            <div className="font-bold text-blue-800">Nathan BENAIS</div>
            <div className="text-[8px]">Développeur Web</div>
            <div className="flex justify-between items-end">
              <div className="text-[7px]">nathan.benais@gmail.com</div>
              <div className="h-3 w-3 bg-blue-800 rounded-full"></div>
            </div>
          </div>
        </div>
      </a>
    );
  }

  // --- rose ---
  if (project.btnType === 'rose') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="group relative inline-flex items-center justify-center px-6 py-3 overflow-hidden font-serif text-rose-800 bg-rose-50 rounded-lg border border-rose-200 shadow-sm">
        <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-rose-100 to-rose-50"></span>
        <span className="absolute top-1/2 left-1/3 transform -translate-y-1/2 -translate-x-full group-hover:translate-x-0 transition-all duration-700 ease-out">
          <svg className="h-6 w-6 text-amber-400" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12,10a2,2,0,1,0,2,2A2,2,0,0,0,12,10Z"/>
          </svg>
        </span>
        <span className="absolute top-1/2 right-1/3 transform -translate-y-1/2 translate-x-full group-hover:translate-x-0 transition-all duration-700 ease-out">
          <svg className="h-6 w-6 text-amber-500" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12,10a2,2,0,1,0,2,2A2,2,0,0,0,12,10Z"/>
          </svg>
        </span>
        <span className="absolute top-0 left-0 opacity-0 group-hover:opacity-30 transition-opacity duration-700 delay-300">
          <svg className="h-6 w-6 text-rose-300" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12,22c4.4,0,8-3.6,8-8s-3.6-8-8-8s-8,3.6-8,8S7.6,22,12,22z M12,8c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S8.7,8,12,8z"/>
            <path d="M12,12c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S13.1,12,12,12z"/>
            <path d="M21,3.6c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S22.1,3.6,21,3.6z"/>
            <path d="M3,3.6c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S1.9,3.6,3,3.6z"/>
            <path d="M21,19.4c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S22.1,19.4,21,19.4z"/>
            <path d="M3,19.4c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S1.9,19.4,3,19.4z"/>
          </svg>
        </span>
        <span className="absolute bottom-0 right-0 opacity-0 group-hover:opacity-30 transition-opacity duration-700 delay-300">
          <svg className="h-6 w-6 text-rose-300" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12,22c4.4,0,8-3.6,8-8s-3.6-8-8-8s-8,3.6-8,8S7.6,22,12,22z M12,8c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S8.7,8,12,8z"/>
            <path d="M12,12c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S13.1,12,12,12z"/>
            <path d="M21,3.6c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S22.1,3.6,21,3.6z"/>
            <path d="M3,3.6c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S1.9,3.6,3,3.6z"/>
            <path d="M21,19.4c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S22.1,19.4,21,19.4z"/>
            <path d="M3,19.4c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S1.9,19.4,3,19.4z"/>
          </svg>
        </span>
        <span className="relative flex items-center gap-3 z-10">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-rose-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
          <span className="font-medium italic">{t.portfolio.seeProject}</span>
        </span>
        <span className="absolute bottom-1 left-1/2 w-0 h-0.5 bg-rose-300 transform -translate-x-1/2 group-hover:w-4/5 transition-all duration-700 ease-out"></span>
      </a>
    );
  }

  // --- lock ---
  if (project.btnType === 'lock') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="group relative inline-flex items-center justify-center px-6 py-3 overflow-hidden font-medium text-white border-2 border-white rounded-full">
        <span className="absolute inset-0 w-full h-full bg-white scale-0 group-hover:scale-100 opacity-20 transition-transform duration-500 ease-out rounded-full"></span>
        <span className="relative flex items-center gap-2">
          {/* Cadenas fermé (visible par défaut) */}
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 group-hover:opacity-0 group-hover:scale-0 transition-all duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
          {/* Cadenas ouvert (visible au survol) */}
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 absolute opacity-0 scale-0 group-hover:opacity-100 group-hover:scale-100 transition-all duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
          </svg>
          {t.portfolio.seeProject}
        </span>
      </a>
    );
  }

  // --- wine ---
  if (project.btnType === 'wine') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="group relative inline-flex items-center justify-center px-6 py-3 overflow-hidden font-medium text-purple-900 bg-amber-100 rounded-full">
        <span className="relative flex items-center gap-2 z-10">
          <svg className="h-5 w-5 transform transition-all duration-300 group-hover:translate-y-1 group-hover:-translate-x-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M8 22H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M9 6.8C9 6.51997 9 6.37996 9.0545 6.27174C9.10243 6.17564 9.17564 6.10243 9.27174 6.0545C9.37996 6 9.51997 6 9.8 6H14.2C14.48 6 14.62 6 14.7283 6.0545C14.8244 6.10243 14.8976 6.17564 14.9455 6.27174C15 6.37996 15 6.51997 15 6.8V12.2C15 12.48 15 12.62 14.9455 12.7283C14.8976 12.8244 14.8244 12.8976 14.7283 12.9455C14.62 13 14.48 13 14.2 13H9.8C9.51997 13 9.37996 13 9.27174 12.9455C9.17564 12.8976 9.10243 12.8244 9.0545 12.7283C9 12.62 9 12.48 9 12.2V6.8Z" fill="currentColor" className="group-hover:fill-amber-800 transition-colors duration-300"/>
            <path className="group-hover:translate-y-6 group-hover:-translate-x-6 transform transition-all duration-500" d="M10 3C10 2.44772 10.4477 2 11 2H13C13.5523 2 14 2.44772 14 3V6H10V3Z" fill="currentColor"/>
          </svg>
          <span>{t.portfolio.seeWines}</span>
        </span>
        <span className="absolute top-0 right-0 w-12 h-12 rounded-full bg-amber-100 opacity-0 group-hover:opacity-30 transform scale-0 group-hover:scale-100 translate-x-3 -translate-y-3 transition-all duration-500"></span>
      </a>
    );
  }

  // --- smiley ---
  if (project.btnType === 'smiley') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="group relative inline-flex items-center justify-center px-6 py-3 font-medium text-white rounded-full overflow-hidden">
        <span className="absolute inset-0 border-2 border-white rounded-full"></span>
        <span className="relative flex items-center gap-3 z-10">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 group-hover:animate-bounce" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          {t.portfolio.seeProject}
        </span>
      </a>
    );
  }

  // --- gradient ---
  if (project.btnType === 'gradient') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="group relative inline-flex items-center justify-center px-6 py-3 font-bold bg-black text-white rounded-full overflow-hidden z-10">
        <span className="absolute inset-0 w-full h-full bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500"></span>
        <span className="absolute inset-0 w-full h-full bg-black transition-all duration-300 scale-95 rounded-full group-hover:scale-100 z-10"></span>
        <span className="relative flex items-center gap-2 z-20">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
          {t.portfolio.seeProject}
        </span>
      </a>
    );
  }

  // --- amber ---
  if (project.btnType === 'amber') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="inline-flex items-center justify-center px-6 py-3 bg-amber-500 text-black font-bold rounded-full shadow-lg transform transition-all duration-300 hover:-translate-y-1 hover:shadow-amber-300/50 hover:shadow-xl">
        <span className="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
          {t.portfolio.seeProject}
        </span>
      </a>
    );
  }

  // --- outline ---
  if (project.btnType === 'outline') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="group relative inline-flex items-center justify-center px-6 py-3 font-medium text-white rounded-full overflow-hidden">
        <span className="absolute inset-0 border-2 border-white rounded-full"></span>
        <span className="absolute inset-0 border-2 border-blue-400 scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left rounded-full"></span>
        <span className="relative flex items-center gap-2 transition-colors duration-300 group-hover:text-blue-200">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
          {t.portfolio.seeProject}
        </span>
      </a>
    );
  }

  // --- outlineBold ---
  if (project.btnType === 'outlineBold') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="relative inline-flex items-center justify-center px-6 py-3 overflow-hidden font-bold text-white border border-white rounded-full hover:border-white group">
        <span className="absolute inset-0 w-full h-full bg-white-600 opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
        <span className="relative flex items-center gap-2 group-hover:text-white-100 transition-all duration-300 transform group-hover:scale-110">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
          {t.portfolio.seeProject}
        </span>
      </a>
    );
  }

  // --- purpleGradient ---
  if (project.btnType === 'purpleGradient') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="relative inline-flex items-center justify-center px-6 py-3 overflow-hidden font-bold bg-gradient-to-r from-purple-500 to-blue-500 rounded-full group">
        <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-white rounded-full group-hover:w-full group-hover:h-56"></span>
        <span className="relative flex items-center gap-2 text-white group-hover:text-blue-600 transition-colors duration-300">
          {t.portfolio.seeProject}
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </span>
      </a>
    );
  }

  // --- outlineSimple ---
  if (project.btnType === 'outlineSimple') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="relative inline-flex items-center justify-center px-6 py-2.5 overflow-hidden font-medium bg-transparent border-2 border-white text-white rounded-full text-xs uppercase tracking-wider hover:bg-white hover:text-black transition-all duration-300">
        <span className="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
          {t.portfolio.seeProject}
        </span>
      </a>
    );
  }

  // --- white ---
  if (project.btnType === 'white') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="group relative inline-flex items-center justify-center px-6 py-2.5 overflow-hidden font-medium bg-white rounded-full text-xs uppercase tracking-wider">
        <span className="relative flex items-center gap-2 text-gray-800 transition duration-300 ease-in-out group-hover:text-black">
          {t.portfolio.seeProject}
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 transition-transform group-hover:rotate-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </span>
      </a>
    );
  }

  // --- whiteArrow ---
  if (project.btnType === 'whiteArrow') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="relative inline-flex items-center justify-center text-xs px-8 py-3 overflow-hidden font-medium text-gray-800 bg-white rounded-md group">
        <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-gray-100 rounded-full group-hover:w-56 group-hover:h-56"></span>
        <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-gray-200"></span>
        <span className="relative flex items-center gap-2">
          <span className="uppercase tracking-wider">{t.portfolio.seeProject}</span>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 transition-all duration-300 ease-in-out transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </span>
      </a>
    );
  }

  // --- whiteHover ---
  if (project.btnType === 'whiteHover') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="group relative inline-flex items-center justify-center px-6 py-2.5 overflow-hidden font-medium bg-white rounded-full text-xs uppercase tracking-wider shadow-md hover:shadow-lg transition-all duration-300">
        <span className="absolute inset-0 w-0 bg-gray-100 transition-all duration-300 ease-out group-hover:w-full"></span>
        <span className="relative flex items-center gap-2 text-gray-800 transition duration-300 ease-in-out">
          {t.portfolio.seeProject}
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:rotate-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </span>
        <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gray-200 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-center"></span>
      </a>
    );
  }

  // --- purple ---
  if (project.btnType === 'purple') {
    return (
      <a href={project.link} target="_blank" rel="noopener noreferrer"
        className="group relative inline-flex items-center justify-center px-6 py-3 overflow-hidden font-medium text-white bg-purple-600 rounded-full">
        <span className="relative flex items-center gap-2 z-10">
          <span className="transform group-hover:scale-0 transition-transform duration-300">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </span>
          <span className="absolute flex group-hover:scale-100 scale-0 transition-transform duration-300">
            <span className="text-xl">🚀</span>
          </span>
          <span className="transition-all duration-300 group-hover:ml-6">{t.portfolio.seeProject}</span>
        </span>
      </a>
    );
  }

  // Fallback
  return (
    <a href={project.link} target="_blank" rel="noopener noreferrer"
      className="group relative inline-flex items-center justify-center px-6 py-3 font-medium text-white rounded-full overflow-hidden border-2 border-white">
      <span className="relative flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
        </svg>
        {t.portfolio.seeProject}
      </span>
    </a>
  );
};

const PortfolioCard = ({ project, t }) => {
  return (
    <div className="card-container h-[275px] w-full">
      <div className="card-wrapper h-full w-full">
        <div className="card h-full w-full">
          <div
            className="card-front rounded-lg overflow-hidden"
            style={{
              backgroundImage: `url('${process.env.PUBLIC_URL}/${project.image}')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>
          <div className="card-back rounded-lg p-6 flex flex-col justify-between">
            <div className="scroller">
              {project.titleCard && (
                <h3 className="text-white font-semibold text-center mb-2"><u>{project.titleCard}</u></h3>
              )}
              <h3 className="text-white font-semibold text-left mb-3">{project.title}</h3>
              <p className="text-white text-sm text-left whitespace-pre-line">
                {project.description}
              </p>
            </div>
            {project.btnType !== 'none' && <ProjectButton project={project} t={t} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioCard;